/* eslint-disable react/prop-types */
import React from 'react';
import { TextField, FormControlLabel, Checkbox } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { ImageUpload } from '../../ImageUpload';
import Place from '../../../utils/constants/place.constant';
export function MaterialForm({
  errors,
  material,
  Controller,
  control,
  materialType,
  selectCustomer,
  setSelectCustomer,
  image,
  setImage,
  watch,
}) {
  const information = useSelector((state) => state.information);
  const {
    setting: { ims: imsSetting },
  } = information;

  const handlePushtoSelectCustomer = (select) => {
    const removeIndex = _.indexOf(selectCustomer, select);
    if (removeIndex > -1) {
      const newArr = _.filter(
        selectCustomer,
        (_customer, index) => index !== removeIndex,
      );
      setSelectCustomer(newArr);
    } else {
      setSelectCustomer([...selectCustomer, select]);
    }
  };
  return (
    <div className="flex flex-row flex-wrap w-full">
      <div className="font-semibold">ข้อมูลสินค้า</div>
      <div className="flex flex-row items-center w-full">
        <div className="w-1/2 px-1 py-2">
          <Controller
            name={'name'}
            control={control}
            defaultValue={material ? material.name : ''}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label="ชื่อสินค้า"
                fullWidth
                size={'small'}
                required
                helperText={errors.name && 'กรุณาใส่ข้อมูล'}
              />
            )}
          />
        </div>
        <div className="w-1/2 px-1 py-2">
          <Controller
            name="isbar"
            control={control}
            defaultValue={material ? material.isbar : false}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                }
                label="ทองคำแท่ง"
              />
            )}
          />
        </div>
      </div>
      <div className="w-full px-1 py-2">
        <div className="font-semibold">ประเภทสินค้า</div>
        {materialType?.rows?.map((type, idx) => (
          <Controller
            key={type._id}
            name={`materialType.rows.${idx}.status`}
            control={control}
            defaultValue={!!type.status}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                }
                label={type.name}
              />
            )}
          />
        ))}
      </div>
      <div>คลัง</div>
      {Object.entries(Place).map(([key, place], idx) => {
        return (
          <Controller
            key={key}
            name={`place.${key}.status`}
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                }
                label={place.description}
              />
            )}
          />
        );
      })}
      <div className="w-full px-1 py-2">
        <Controller
          name={'detail'}
          control={control}
          defaultValue={material ? material.detail : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="รายละเอียด"
              fullWidth
              rows={2}
              multiline={true}
              size={'small'}
              helperText={errors.detail && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      {/* <div className="w-full px-1 py-2">
        <ImageUpload images={image} maxNumber={1} setImages={setImage} />
      </div> */}
    </div>
  );
}

MaterialForm.propTypes = {
  errors: PropTypes.shape({
    name: PropTypes.object,
    unit: PropTypes.object,
    net: PropTypes.object,
    unit_net: PropTypes.object,
    gold_bar: PropTypes.object,
    detail: PropTypes.object,
    place: PropTypes.object,
    minimum_amount: PropTypes.object,
  }),
  material: PropTypes.object,
  materialType: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
  image: PropTypes.arrayOf(PropTypes.object),
  setImage: PropTypes.func,
};

MaterialForm.defaultProps = {
  material: null,
  materialType: null,
  customerType: null,
};

export default MaterialForm;
